export const getIdStart = (id = '') => id.substring(0, 8);

export const generateUniqueString = () => {
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substring(2, 15);

  return `${timestamp}-${randomString}`;
};
